// libs
import React, { useRef, useEffect, memo } from 'react';

// defs
interface IMeasureWidth {
  children: React.ReactNode;
  onMeasured: (width: number) => void;
}

const containerStyle: React.CSSProperties = {
  width: 'auto',
  position: 'absolute',
  visibility: 'hidden',
  left: '-999px',
  height: '0',
  overflowX: 'auto',
};

function MeasureWidth({ children, onMeasured }: IMeasureWidth) {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (elRef.current === null) {
      return;
    }

    const el = elRef.current;
    const timerId = setTimeout(() => {
      onMeasured(el.scrollWidth);
    }, 0);

    return () => clearTimeout(timerId);
  }, [onMeasured]);

  return (
    <div style={containerStyle} ref={elRef}>
      {children}
    </div>
  );
}

export default memo(MeasureWidth);
